<template>
  <common-page
    ref="commonPage"
    :bg-path="bgPath"
    :web-path="webPath"
    :columns="columns"
    :search-items="searchItems"
    :form-items="formItems"
    :table-options="tableOptions"
    :d-table-config="dTableConfig"
  >
    <template #form-bottom>
      <d-table />
    </template>
  </common-page>
</template>
<script>
import DTable from "@/components/TkCommonPage/components/DTable.vue"
export default {
  components: { DTable },
  data() {
    return {
      // ===== ===== ===== ===== 全局属性 ===== ===== ===== =====
      // 后台接口路径
      bgPath: 'pharmacy/storage/agentpre/chagentprescription',
      // Web路径
      webPath: 'pharmacy/storage/agentpre/chagentprescription',
      tableOptions: ['details', 'filter'],
      // ===== ===== ===== ===== 页面配置 ===== ===== ===== =====
      // 搜索内容
      searchItems: [
        {
          rowIndex: 1,
          items: [
            {
              code: "code",
              name: "编码",
              span: 6,
              type: "text",
              config: {
                edit: false,
                rules: [
                  { required: true, message: '请输入编码', trigger: 'blur' }
                ]
              }
            },

            {
              code: "storeCode",
              name: "门店编码",
              span: 6,
              type: "popup",
              config: {
                url: "base/user/user/store",
                filedList: [
                  { code: 'id', name: 'ID' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: {},
                minLength: 0,
                maxLength: 20,
                disabled: false,
                rules: [

                ]
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateTitleData(code, row.code)
                  this.$refs.commonPage.updateTitleData("storeName", row.name)
                  this.$refs.commonPage.updateTitleData("storeId", row.id)
                }
              }
            },
            {
              code: "storeName",
              name: "门店名称",
              span: 6,
              type: "text",
              config: {
                edit: false,
                disable: true
              }
            },
            {
              code: "storeUserCode",
              name: "门店人员编码",
              type: "popup",
              span: 6,
              config: {
                url: "base/user/user/storeuser",
                filedList: [
                  { code: 'id', name: 'Id' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: {},
                minLength: 0,
                maxLength: 20,
                disabled: false,
                rules: [
                  { required: true, message: '请选择门店人员', trigger: 'change' }
                ]
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateTitleData(code, row.code)
                  this.$refs.commonPage.updateTitleData("storeUserName", row.name)
                  this.$refs.commonPage.updateTitleData("storeUserId", row.id)
                }
              }
            }, {
              code: "storeUserName",
              name: "门店人员名称",
              span: 6,
              type: "text",
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "doseNum",
              name: "总剂数",
              span: 6,
              type: "number",
              config: {
                edit: false
              }
            },
            {
              code: "serveFeeSign",
              name: "服务型标识",
              span: 6,
              type: "select",
              search: true,
              config: {
                edit: false,
                options: [{ key: "00", value: "不加工" }, { key: "01", value: "代煎" }, { key: "11", value: "制粒" }, {
                  key: "21",
                  value: "细粉打粉"
                }, { key: "22", value: "粗粉打粉" }, { key: "31", value: "水丸制丸" }, {
                  key: "32",
                  value: "蜜丸制丸"
                }, { key: "33", value: "大蜜丸制丸" }, { key: "34", value: "浓缩丸制丸" }, {
                  key: "35",
                  value: "水蜜丸制丸"
                }, { key: "41", value: "制瓶装膏" }, { key: "42", value: "制袋装膏" }, {
                  key: "43",
                  value: "制块装膏"
                }
                ]
              }
            },
            {
              code: "decoctPrice",
              name: "加工费",
              span: 6,
              type: "number",
              config: {
                edit: false
              }
            },
            {
              code: "saleAmount",
              name: "销售金额",
              span: 6,
              type: "number",
              config: {
                edit: false
              }
            },
            {
              code: "stateSign",
              name: "状态标识",
              span: 6,
              type: "select",
              config: {
                edit: false,
                options: [
                  { key: "1", value: "待制药" },
                  { key: "2", value: "已完成" }

                ]
              }
            },
            {
              code: "contactName",
              name: "联系人",
              span: 6,
              type: "text",
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "contactPhone",
              name: "联系电话",
              span: 6,
              type: "text",
              config: {
                edit: false
              }
            },
            {
              code: "contactAddress",
              name: "联系地址",
              span: 6,
              type: "text",
              config: {
                edit: false
              }
            }

          ]
        }
      ],
      // 列表内容
      columns: [
        {
          code: "code",
          name: "编码",
          span: 6,
          type: "text",
          config: {
            edit: false,
            rules: [
              { required: true, message: '请输入编码', trigger: 'blur' }
            ]
          }
        },

        {
          code: "stdPrescriptionId",
          name: "标准处方ID",
          span: 6,
          type: "text",
          config: {
            edit: false,
            disabled: true
          }
        },
        {
          code: "stdPrescriptionName",
          name: "标准处方名称",
          span: 6,
          type: "text",
          config: {
            edit: false,
            disabled: true
          }
        },
        {
          code: "treatmentCode",
          span: 6,
          name: "诊疗记录编码",
          type: "text",
          config: {
            edit: false,
            disabled: true
          }
        },
        {
          code: "storeUserCode",
          name: "医生编码",
          span: 6,
          type: "text",
          config: {
            edit: false,
            disabled: true
          }
        },
        {
          code: "storeUserName",
          name: "医生名称",
          span: 6,
          type: "text",
          config: {
            edit: false,
            disabled: true
          }
        },
        {
          code: "pharmacyCode",
          span: 6,
          name: "中心药房编码",
          type: "text",
          config: {
            edit: false,
            disabled: true
          }
        },
        {
          code: "pharmacyName",
          name: "中心药房名称",
          type: "text",
          span: 6,
          config: {
            edit: false,
            disabled: true
          }
        },
        {
          code: "dayNum",
          name: "用药天数",
          span: 6,
          type: "number",
          config: {
            edit: false
          }
        },
        {
          code: "doseNum",
          name: "总剂数",
          span: 6,
          type: "number",
          config: {
            edit: false
          }
        },
        {
          code: "dayDoseNum",
          name: "每日次数",
          span: 6,
          type: "number",
          config: {
            edit: false
          }
        },
        {
          code: "dayFreq",
          name: "每日剂数",
          span: 6,
          type: "number",
          config: {
            edit: false
          }
        },
        {
          code: "serveFeeSign",
          name: "服务型标识",
          span: 6,
          type: "select",
          search: true,
          config: {
            edit: false,
            options: [{ key: "00", value: "不加工" }, { key: "01", value: "代煎" }, { key: "11", value: "制粒" }, {
              key: "21",
              value: "细粉打粉"
            }, { key: "22", value: "粗粉打粉" }, { key: "31", value: "水丸制丸" }, {
              key: "32",
              value: "蜜丸制丸"
            }, { key: "33", value: "大蜜丸制丸" }, { key: "34", value: "浓缩丸制丸" }, {
              key: "35",
              value: "水蜜丸制丸"
            }, { key: "41", value: "制瓶装膏" }, { key: "42", value: "制袋装膏" }, {
              key: "43",
              value: "制块装膏"
            }
            ]
          }
        },
        {
          code: "costDecoctPrice",
          name: "加工费成本",
          span: 6,
          type: "number",
          config: {
            edit: false
          }
        },
        {
          code: "saleDecoctPrice",
          name: "加工费金额",
          span: 6,
          type: "number",
          config: {
            edit: false
          }
        },
        {
          code: "costAmount",
          name: "成本金额",
          span: 6,
          type: "number",
          config: {
            edit: false
          }
        },
        {
          code: "saleAmount",
          name: "销售金额",
          span: 6,
          type: "number",
          config: {
            edit: false
          }
        },
        {
          code: "stateSign",
          name: "状态标识",
          span: 6,
          type: "select",
          config: {
            edit: false,
            options: [
              { key: "1", value: "待制药" },
              { key: "2", value: "已完成" }

            ]
          }
        },
        {
          code: "contactName",
          name: "联系人",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "contactPhone",
          name: "联系电话",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "contactAddress",
          name: "联系地址",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        }
      ],
      // 增加/修改/详情 表单
      formItems: [
        {
          rowIndex: 1,
          items: [
            {
              code: "code",
              name: "编码",
              span: 6,
              type: "text",
              config: {
                edit: false,
                rules: [
                  { required: true, message: '请输入编码', trigger: 'blur' }
                ]
              }
            },

            {
              code: "stdPrescriptionId",
              name: "标准处方ID",
              span: 6,
              type: "popup",
              config: {
                url: "clinic/treatment/stdprescription/stdprescription",
                filedList: [
                  { code: 'id', name: 'ID' },
                  { code: 'name', name: '名称' }
                ],
                searcher: {},
                defaultValue: "",
                minLength: 0,
                maxLength: 20,
                disabled: false,
                require: true,
                rules: [

                ]
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateFormData(code, row.code)
                  this.$refs.commonPage.updateFormData("stdPrescriptionName", row.name)
                  this.$refs.commonPage.updateFormData("stdPrescriptionId", row.id)
                }
              }
            },
            {
              code: "stdPrescriptionName",
              name: "标准处方名称",
              span: 6,
              type: "text",
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "treatmentCode",
              span: 6,
              name: "诊疗记录编码",
              type: "popup",
              config: {
                url: "clinic/treatment/treatment/treatmentrecord",
                filedList: [
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: {},
                defaultValue: "",
                minLength: 0,
                maxLength: 20,
                disabled: false,
                require: true
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateFormData("patientCode", row.patientCode)
                  this.$refs.commonPage.updateFormData("patientName", row.patientName)
                  this.$refs.commonPage.updateFormData("patientId", row.patientId)
                  this.$refs.commonPage.updateFormData(code, row.code)
                  this.$refs.commonPage.updateFormData("treatmentName", row.name)
                  this.$refs.commonPage.updateFormData("treatmentId", row.id)
                }
              }
            },
            {
              code: "storeUserCode",
              name: "医生编码",
              type: "popup",
              span: 6,
              config: {
                url: "base/user/user/storeuser",
                filedList: [
                  { code: 'id', name: 'Id' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: {},
                defaultValue: "",
                minLength: 0,
                maxLength: 20,
                disabled: false,
                rules: [
                  { required: true, message: '请选择医生', trigger: 'change' }
                ]
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateFormData(code, row.code)
                  this.$refs.commonPage.updateFormData("storeUserName", row.name)
                  this.$refs.commonPage.updateFormData("storeUserId", row.id)
                }
              }
            },
            {
              code: "storeUserName",
              name: "医生名称",
              span: 6,
              type: "text",
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "pharmacyCode",
              span: 6,
              name: "中心药房编码",
              type: "popup",
              config: {
                url: "base/user/user/pharmacy",
                filedList: [
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: {},
                defaultValue: "",
                minLength: 0,
                maxLength: 20,
                disabled: false,
                require: true
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateFormData(code, row.code)
                  this.$refs.commonPage.updateFormData("pharmacyName", row.name)
                  this.$refs.commonPage.updateFormData("pharmacyId", row.id)
                }
              }
            },
            {
              code: "pharmacyName",
              name: "中心药房名称",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "dayNum",
              name: "用药天数",
              span: 6,
              type: "number",
              config: {
                edit: false
              }
            },
            {
              code: "doseNum",
              name: "总剂数",
              span: 6,
              type: "number",
              config: {
                edit: false
              }
            },
            {
              code: "dayDoseNum",
              name: "每日次数",
              span: 6,
              type: "number",
              config: {
                edit: false
              }
            },
            {
              code: "dayFreq",
              name: "每日剂数",
              span: 6,
              type: "number",
              config: {
                edit: false
              }
            },
            {
              code: "serveFeeSign",
              name: "服务型标识",
              span: 6,
              type: "select",
              search: true,
              config: {
                edit: false,
                defaultValue: '00',
                options: [{ key: "00", value: "不加工" }, { key: "01", value: "代煎" }, { key: "11", value: "制粒" }, {
                  key: "21",
                  value: "细粉打粉"
                }, { key: "22", value: "粗粉打粉" }, { key: "31", value: "水丸制丸" }, {
                  key: "32",
                  value: "蜜丸制丸"
                }, { key: "33", value: "大蜜丸制丸" }, { key: "34", value: "浓缩丸制丸" }, {
                  key: "35",
                  value: "水蜜丸制丸"
                }, { key: "41", value: "制瓶装膏" }, { key: "42", value: "制袋装膏" }, {
                  key: "43",
                  value: "制块装膏"
                }
                ]
              }
            },
            {
              code: "costDecoctPrice",
              name: "加工费成本",
              span: 6,
              type: "number",
              config: {
                edit: false
              }
            },
            {
              code: "saleDecoctPrice",
              name: "加工费金额",
              span: 6,
              type: "number",
              config: {
                edit: false
              }
            },
            {
              code: "costAmount",
              name: "成本金额",
              span: 6,
              type: "number",
              config: {
                edit: false
              }
            },
            {
              code: "saleAmount",
              name: "销售金额",
              span: 6,
              type: "number",
              config: {
                edit: false
              }
            },
            {
              code: "stateSign",
              name: "状态标识",
              span: 6,
              type: "select",
              config: {
                edit: false,
                defaultValue: '1',
                options: [
                  { key: "1", value: "待制药" },
                  { key: "2", value: "已完成" }

                ]
              }
            },
            {
              code: "contactName",
              name: "联系人",
              span: 6,
              type: "text",
              config: {
                edit: false
              }
            },
            {
              code: "contactPhone",
              name: "联系电话",
              span: 6,
              type: "text",
              config: {
                edit: false
              }
            },
            {
              code: "contactAddress",
              name: "联系地址",
              span: 6,
              type: "text",
              config: {
                edit: false
              }
            }
          ]
        }],

      // 子表配置
      dTableConfig: [
        {
          key: "chagentPrescriptionItem",
          name: "代煎处方项",
          url: "pharmacy/storage/agentpre/chagentprescriptionitem",
          columns: [
            {
              code: "materielCode",
              name: "药品编码",
              type: "popup",
              span: 6,
              config: {
                url: "base/dictionary/medicinedic/materiel",
                filedList: [
                  { code: 'id', name: 'Id' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                disabled: false,
                rules: [
                  { required: true, message: "请选择药品", trigger: "change" }
                ]
              },

              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (line, code, row) => {
                  this.$refs.commonPage.updateDTableData(line, 'chagentPrescriptionItem', code, row.code)
                  this.$refs.commonPage.updateDTableData(line, 'chagentPrescriptionItem', "materielName", row.name)
                  this.$refs.commonPage.updateDTableData(line, 'chagentPrescriptionItem', "materielId", row.id)
                }
              }
            },
            {
              code: "materielName",
              name: "药品名称",
              span: 6,
              type: "text",
              config: {
                edit: false
              }
            },
            {
              code: "medSpecCode",
              name: "药品规格编码",
              type: "popup",
              span: 6,
              config: {
                url: "base/dictionary/medicinedic/meddictionary",
                filedList: [
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: { medDirectoryCode: "DW" },
                defaultValue: "",
                minLength: 0,
                maxLength: 20,
                disabled: false
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (line, code, row) => {
                  this.$refs.commonPage.updateDTableData(line, 'chagentPrescriptionItem', code, row.code)
                  this.$refs.commonPage.updateDTableData(line, 'chagentPrescriptionItem', "medSpecName", row.name)
                  this.$refs.commonPage.updateDTableData(line, 'chagentPrescriptionItem', "medSpecId", row.id)
                }
              }
            },
            {
              code: "medSpecName",
              name: "药品规格名称",
              type: "text",
              span: 6,
              config: {
                edit: false
              }
            },
            {
              code: "medDosageCode",
              name: "药品剂型编码",
              type: "popup",
              span: 6,
              config: {
                url: "base/dictionary/medicinedic/meddictionary",
                filedList: [
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: { medDirectoryCode: "XJ" },
                defaultValue: "",
                minLength: 0,
                maxLength: 20,
                disabled: false
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (line, code, row) => {
                  this.$refs.commonPage.updateDTableData(line, 'chagentPrescriptionItem', code, row.code)
                  this.$refs.commonPage.updateDTableData(line, 'chagentPrescriptionItem', "medDosageName", row.name)
                  this.$refs.commonPage.updateDTableData(line, 'chagentPrescriptionItem', "medDosageId", row.id)
                }
              }
            },
            {
              code: "medDosageName",
              name: "药品剂型名称",
              type: "text",
              span: 6,
              config: {
                edit: false
              }
            },
            {
              code: "qualitySign",
              name: "品质标识",
              type: "select",
              span: 6,
              config: {
                edit: false,
                keyField: "key",
                valueField: "value",
                options: [
                  { key: "1", value: "普通" },
                  { key: "2", value: "精品" }
                ]
              }
            },
            {
              code: "sellingNum",
              name: "销售数量",
              span: 6,
              type: "number",
              config: {
                edit: false,
                width: 200
              }
            },
            {
              code: "salePrice",
              name: "销售单价",
              span: 6,
              type: "number",
              config: {
                edit: false,
                width: 200
              }
            },
            {
              code: "salePrice",
              name: "销售金额",
              span: 6,
              type: "number",
              config: {
                edit: false,
                width: 200
              }
            },
            {
              code: "costPrice",
              name: "成本单价",
              span: 6,
              type: "number",
              config: {
                edit: false,
                width: 200
              }
            },
            {
              code: "costAmount",
              name: "成本金额",
              span: 6,
              type: "number",
              config: {
                edit: false,
                width: 200
              }
            },
            {
              code: "medUomCode",
              name: "药品单位编码",
              type: "popup",
              span: 6,
              config: {
                url: "base/dictionary/medicinedic/meddictionary",
                filedList: [
                  { code: 'id', name: 'Id' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: {
                  medDirectoryCode: "DW"
                },
                disabled: false,
                rules: [
                  { required: true, message: '请选择药品单位', trigger: 'change' }
                ]
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (line, code, row) => {
                  this.$refs.commonPage.updateDTableData(line, 'chagentPrescriptionItem', code, row.code)
                  this.$refs.commonPage.updateDTableData(line, 'chagentPrescriptionItem', "medUomName", row.name)
                  this.$refs.commonPage.updateDTableData(line, 'chagentPrescriptionItem', "medUomId", row.id)
                }
              }
            },
            {
              code: "medUomName",
              name: "药品单位名称",
              span: 6,
              type: "text",
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "dayNum",
              name: "用药天数",
              span: 6,
              type: "number",
              config: {
                edit: false
              }
            },
            {
              code: "dayFreq",
              name: "每次次数",
              span: 6,
              type: "number",
              config: {
                edit: false,
                width: 200
              }
            },
            {
              code: "dayFreq",
              name: "每次次数",
              span: 6,
              type: "number",
              config: {
                edit: false,
                width: 200
              }
            },
            {
              code: "freqNum",
              name: "每次剂量",
              span: 6,
              type: "number",
              config: {
                edit: false,
                width: 200
              }
            },
            {
              code: "meaUomCode",
              name: "剂量单位编码",
              type: "popup",
              span: 6,
              config: {
                url: "base/dictionary/medicinedic/meddictionary",
                filedList: [
                  { code: 'id', name: 'Id' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: {
                  medDirectoryCode: "DW"
                },
                disabled: false,
                rules: [
                  { required: true, message: '请选择药品单位', trigger: 'change' }
                ]
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (line, code, row) => {
                  this.$refs.commonPage.updateDTableData(line, 'chagentPrescriptionItem', code, row.code)
                  this.$refs.commonPage.updateDTableData(line, 'chagentPrescriptionItem', "meaUomName", row.name)
                  this.$refs.commonPage.updateDTableData(line, 'chagentPrescriptionItem', "meaUomId", row.id)
                }
              }
            },
            {
              code: "meaUomName",
              name: "剂量单位名称",
              span: 6,
              type: "text",
              config: {
                edit: false,
                disabled: true
              }
            }

          ]
        }
      ]
    }
  }
}
</script>
